import * as actions from './actions';
import * as constants from './constants';
import reducer from './reducer';
import * as utils from './utils';

export default {
    actions,
    constants,
    reducer,
    utils
};



// WEBPACK FOOTER //
// ./src/services/partner/index.js